module.exports = __webpack_public_path__ + "img/sicon_03.57da7167.png";